import { render } from "./ModalResponsavelConta.vue?vue&type=template&id=76064987&scoped=true"
import script from "./ModalResponsavelConta.vue?vue&type=script&lang=js"
export * from "./ModalResponsavelConta.vue?vue&type=script&lang=js"

import "./ModalResponsavelConta.vue?vue&type=style&index=0&id=76064987&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76064987"]])

export default __exports__